import { Api } from '../helpers';

const mapModel = {
  getOrderTrackData(params) {
    const queryParams = params;
    const path = 'order/get_track_data';
    return Api.get({ path, queryParams });
  },
  getOrderRunData(params) {
    const queryParams = params;
    const path = 'order/get_order_run';
    return Api.get({ path, queryParams });
  },
};

export default mapModel;
